module.exports = __webpack_public_path__ + "static/media/sound.0128c6e4.gif";